export const version = '2.9.2';
//# sourceMappingURL=version.js.map